const usernameFormatter = (value: string): string => {

  const cleanValue = value.replace(/\D/g, "");

  if (cleanValue.length === 12) {
    return cleanValue.replace(/(\d{11})(\d{1})/, '$1.$2');
  }

  return value;
};

export { usernameFormatter };
